


















































import Vue from 'vue'
import { TextInput } from '@raksul/raksul-common-ui'

import SizeInput from '@/common/components/SizeInput.vue'

import SizeItem from '@/groupBuy/types'

export default Vue.extend({
  components: {
    TextInput,
    SizeInput
  },
  props: {
    availableSizes: {
      type: Array as () => { id: string, name: string }[],
      required: true
    },
    initInput: {
      type: Array as () => SizeItem[],
      default: () => []
    },
    initName: {
      type: String,
      default: ''
    }
  },
  data(): {
    username: string
    sizeList: {id: string, name: string, quantity: number}[]
  } {
    return {
      username: this.initName,
      sizeList: []
    }
  },
  computed: {
    validInputSize(): boolean {
      return this.sizeList.some(item => item.quantity > 0)
    }
  },
  created() {
    const initInputMap = this.initInput.reduce((obj: {[key: string]: number}, item) => {
      obj[item.sizeId] = item.quantity
      return obj
    }, {})
    this.sizeList = this.availableSizes.map(item => {
      return {
        id: item.id,
        name: item.name,
        quantity: initInputMap[item.id] || 0
      }
    })
  },
  methods: {
    save() {
      const payload = {
        username: this.username,
        sizeItems: this.sizeList.map(item => {
          return {
            id: item.id,
            quantity: item.quantity
          }
        })
      }
      this.$emit('save', payload)
    }
  }
})
